import features from 'features';
import get from 'lodash/get';
import type { IUser } from 'types/users.types';
import { DEFAULT_COUNTRY } from './defaults';

const getUserFeatures = (user: IUser): Record<string, any> =>
  get(features, user?.country || DEFAULT_COUNTRY);

export default getUserFeatures;
